<template>
  <div class="campaign-preview">
    <p class="campaign-preview__title">
      {{ tStatic('campaignPreviewTitle') }}
    </p>
    <ul class="campaign-preview__list">
      <li v-for="(campaign, i) in campaignPreview" :key="`campaign__${i}`">
        <oie-campaign-preview-block :campaign="campaign"></oie-campaign-preview-block>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import httpService from '@/core/http-service'
import _ from 'lodash'
import priceService from '@/core/price-service'

export default {
  data() {
    return {
      campaignPreview: []
    }
  },
  computed: {
    ...mapGetters('commerce', ['currentProduct']),
    ...mapGetters('ui', ['useVat'])
  },
  watch: {
    currentProduct() {
      this.getCampaignPreview()
    },
    useVat() {
      this.getCampaignPreview()
    }
  },
  methods: {
    async getCampaignPreview() {
      const { data } = await httpService.post('campaignpreviews', { productId: [this.currentProduct.id] })
      const enrichedWithPrices = _.map(data, async (campaign) => {
        const products = campaign.products
        const productIds = _.map(products, product => product.id)
        const prices = await httpService.post('productListPrices', { productId: productIds, currentProduct: this.currentProduct.id })
        priceService.populatePricesFromBackend(prices.data, products)
      })
      await Promise.all(enrichedWithPrices)
      this.campaignPreview = data
    }
  }
}
</script>

<style lang="scss">

.campaign-preview__title {
  @include h2-bold;
  margin-top: 0;
}

.campaign-preview__list {
  @include reset-list;

}

.campaign-preview__list >:not(:last-child){
  margin-bottom: measure(half);
}

.product-tabs__trigger.js-tab-trigger.campaign-tab {
  border: 1px solid color(campaign-red);
  color: color(campaign-red);
  background: color(white);
}

.product-tabs__trigger.js-tab-trigger.campaign-tab[aria-expanded="true"] {
  border-bottom: 0.3rem solid color(campaign-red);
}

</style>
